import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MemberPage } from "@/features/member/MemberPage";
import { MEMBER_TABS } from "@/features/member/route-params";

const search = z.object({
  tab: z.enum(MEMBER_TABS).optional(),
});

export const Route = createFileRoute("/_app/team/$member")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { member } = Route.useParams();
  return <MemberPage id={member} search={Route.useSearch()} />;
}
